// @ts-nocheck
import React, {useState} from "react";
import t from "../helpers/t";
import {$} from "../../../vendor";
//import CreatableSelect from 'react-select/creatable';
import {getHours, getMinutes, setHours, setMinutes, setSeconds} from "date-fns";
import {in_array} from "../../utils/Helper";

type Props = {
    minTime: Date|string|null,
    maxTime: Date|string|null,
    value?: Date|string|null,
    step?: number|null,
    changeHandler: (date: Date) => void,
    extraClasses?: string|null,
    uid?: string|null
}
const TimeSelect = ({minTime, maxTime,value,step, changeHandler, extraClasses, uid} : Props) =>
{
    const [currentVal, setCurrentVal] = useState(typeof value === 'undefined'?null:value);
    if(minTime === null){
        minTime = setHours(setMinutes(new Date(), 0), 0);
    }
    if(maxTime === null){
        maxTime = setHours(setMinutes(new Date(), 59), 23)
    }
    if(typeof value === 'undefined'){
        value = null;
    }
    if(typeof step === 'undefined' || step === null){
        step = 15;
    }
    if(typeof extraClasses === 'undefined' || extraClasses === null){
        extraClasses = '';
    }
    if(typeof uid === 'undefined' || uid === null){
        uid = '';
    }
    const convert = (count: number) => {
        let hours = 0, minutes = 0;
        if(count >= 60){
            minutes = count % 60;
            hours = (count - minutes) / 60;
        } else {
            minutes = count;
        }
        // convert to string
        return {
            time:(hours < 10?'0'+hours.toString():hours.toString())+":"+(minutes < 10?'0'+minutes.toString():minutes.toString()),
            hours: hours,
            minutes: minutes
        }
    }
    const convertStringTime = (value:string, max:boolean = false) => {
        value=value.toString();
        let t = value.split(':');
        return (max && t[0] === '00'?(24*60):((Number(t[0]) * 60) + Number(t[1])));
    }
    const convertDateToString = (date:Date|string|null) => {
        if(date === null){
            date = new Date();
        }
        if(typeof date === 'string'){
            return date;
        }
        let hours = getHours(date);
        let minutes = getMinutes(date);
        return (hours < 10?'0':'')+hours.toString()+':'+(minutes < 10?'0':'')+minutes.toString();
    }
    if(convertDateToString(maxTime)==="23:45"){
        maxTime = setHours(setMinutes(new Date(), 59), 59)
    }
    let times = [];
    for(let i = 0; i< (24*60); i += step){
        let active = true;
        let time = convert(i);
        if(i < convertStringTime(convertDateToString(minTime)) || i > convertStringTime(convertDateToString(maxTime),true)){
            active = false;
        }
        times.push({
            label: time.time,
            active: active,
            value: time.time,
            selected: (value === time+'00'),
            isMaxTime: false
        });
    }
    if(times.length > 0){times.push({
        label: '00:00',
        active: (convertDateToString(maxTime) === '23:59'),
        value: "23:59",
        selected: (convertDateToString(value) === "23:59"),
        isMaxTime: true
    });}

    const handleSelectChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if($('#timeSelect'+uid).hasClass('errorTime')) $('#timeSelect'+uid).removeClass('errorTime');
        if(!$('#timeSelectError'+uid).hasClass('depend')) $('#timeSelectError'+uid).addClass('depend');

        let skip = false;

        if(e.target.value.includes(':')){
            if(e.target.value.length === 2) {
                e.target.value = "0" + e.target.value;
                skip = true;
            } else {
                if (e.target.value.length === 5) {
                    let lass = e.target.value.split(':');
                    let set = false;
                    let possibleSets:(string)[] = [];
                    valid_set_times.map(ta =>{
                        let ls = ta.split(':');
                       if(ls[0] === lass[0]){
                           possibleSets.push(ls[1]);
                       }
                    });
                    if(in_array(lass[1],possibleSets)) {
                       set = true;
                    }
                    possibleSets.map(ts => {
                        if(!set && Number(ts) > Number(lass[1])){
                            lass[1] = ts;
                            set = true;
                        }
                    });
                    if(!set){
                        let set2 = true;
                        valid_set_times.map(ta =>{
                            let ls = ta.split(':');
                            if(Number(ls[0]) > Number(lass[0]) && set2){
                                possibleSets.push(ls[1]);
                                lass[0] = ls[0];
                                set2 = false;
                            }
                        });
                        if(in_array(lass[1],possibleSets)) {
                            set = true;
                        }
                        possibleSets.map(ts => {
                            if(!set && Number(ts) > Number(lass[1])){
                                lass[1] = ts;
                                set = true;
                            }
                        });
                    }
                    e.target.value = lass[0] + ':' + lass[1];
                }
            }
        }

        let strSplit = e.target.value.split('');
        let err = false;
        strSplit.map((char,index) =>{
           if(isNaN(parseInt(char)) && char !== ":"){
               err = true;
           }
           if(char === ":"){
               if(index !== 0 && strSplit[index-1] === ":"){
                   err = true;
               }
           }
        });

        if(err){
           /*console.log("regex failed");
            if(!$('#timeSelect'+uid).hasClass('errorTime')) $('#timeSelect'+uid).addClass('errorTime');
            if($('#timeSelectError'+uid).hasClass('depend')) $('#timeSelectError'+uid).removeClass('depend');*/
            return;
        }
        if(e.target.value.length === 2){
            e.target.value += ":";
        }
        setCurrentVal(e.target.value);
        let regex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        if(e.target.value.match(regex) === null && !skip){
            /*console.log("regex failed");
             if(!$('#timeSelect'+uid).hasClass('errorTime')) $('#timeSelect'+uid).addClass('errorTime');
             if($('#timeSelectError'+uid).hasClass('depend')) $('#timeSelectError'+uid).removeClass('depend');*/
            return;
        }
        if(e.target.value.length < 5) return;
        let val = null;
        if(e.target.value === "23:59"){
            val = e.target.value + ":59";
        } else {
            val = e.target.value + ":00";
        }
        let time = convertStringTime(e.target.value);
        if(times.length > 0 && (time < convertStringTime(convertDateToString(minTime)) || time > convertStringTime(convertDateToString(maxTime)))){
            console.log("min max failed");
            console.log(convertStringTime(convertDateToString(minTime)))
            console.log(convertStringTime(convertDateToString(maxTime)))
            console.log(time)
            $('#timeSelect'+uid).addClass('errorTime');
            $('#timeSelectError'+uid).removeClass('depend');
        } else {

            let vals = e.target.value.split(':');
            changeHandler(setHours(setMinutes(setSeconds(new Date(),(e.target.value === "23:59"?59:0)),Number(vals[1])),Number(vals[0])));
        }
    };
    let valid_set_times:(string)[] = [];

    return (
        <>
            <div className={"react-datepicker-wrapper "+extraClasses}>
                <div className="react-datepicker__input-container">
                    <input id={"timeSelect"+uid} type="text" list={"times_"+uid} onChange={handleSelectChange} value={(currentVal !== null && currentVal !== ""?convertDateToString(currentVal):"")} />
                    <span id={"timeSelectError"+uid} className="text-small depend" style={{color:"red"}}>{t('not a valid value')}</span>
                        <datalist id={"times_"+uid}>
                        {times.map(time => {
                            return (
                                <>
                                {time.active && valid_set_times.push(time.value) && <option className={(!time.active?"disabled":"")}  key={time.value} value={time.value} selected={time.selected} disabled={!time.active}>{time.label}</option>}
                                </>
                            )
                        })}
                        </datalist>
                </div>
            </div>
        </>
    )
}

export default TimeSelect